
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"41.5","height":"29","rx":"3.5","fill":"#fff","stroke":"#B2BCCA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.474 21.037c-1.48 1.247-3.4 2-5.498 2-4.681 0-8.476-3.75-8.476-8.374 0-4.626 3.795-8.375 8.476-8.375 2.098 0 4.018.753 5.498 2 1.48-1.247 3.4-2 5.497-2 4.682 0 8.476 3.75 8.476 8.374 0 4.626-3.794 8.376-8.476 8.376a8.503 8.503 0 01-5.497-2.001z","fill":"#ED0006"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.474 21.037a8.316 8.316 0 002.978-6.374 8.316 8.316 0 00-2.978-6.375c1.48-1.247 3.4-2 5.497-2 4.681 0 8.476 3.75 8.476 8.374 0 4.626-3.795 8.376-8.476 8.376a8.503 8.503 0 01-5.497-2.001z","fill":"#F9A000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.474 21.037a8.316 8.316 0 002.978-6.374 8.316 8.316 0 00-2.978-6.375 8.316 8.316 0 00-2.978 6.375 8.316 8.316 0 002.978 6.374z","fill":"#FD6020"}})])
          )
        }
      }
    